import React, { useMemo, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { Form } from '@whalecloud/fdx';
import { renderFormItems } from '@/utils';

import { getExpandFormItems } from './utils';

const ExpandeForm = props => {
  const { offerInfo, serviceType, refInstance, form, tabKey, activeDepPlanPanels, onCollapseChange } = props;
  const { getFieldDecorator, validateFields } = form;

  useImperativeHandle(refInstance, () => ({
    getExpendeValue: async() => {
      const formInfo = await validateFields((err, value) => {
        if (err) {
          activeDepPlanPanels.push(tabKey);
          onCollapseChange([...new Set(activeDepPlanPanels)]); // 去重
        }
      });
      const result = {};
      Object.keys(formInfo).forEach(it => {
        if (it.includes('empty')) { // 去除多余的empty数据
          return;
        }
        result[it] = formInfo.it;
      });
      return {};
    },
  }));

  const getAttrValue = attrCode => {
    const attrDtoList = get(offerInfo, 'attrDtoList') || [];
    const attrInfo = attrDtoList.find(it => it.attrCode === attrCode) || {};
    return attrInfo.defaultValue;
  };
  const formItems = useMemo(() => getExpandFormItems({
    serviceType,
    maxIPNum: getAttrValue('EXP_IP_MAXNUM'),
  }), [serviceType, offerInfo]);

  return (
    <Form layout="inline">
      {renderFormItems(formItems, getFieldDecorator)}
    </Form>
  );
};

const Component = connect()(Form.create({
  onValuesChange: (props, changedValues, allValues) => {
    const formInfo = { ...allValues };
    const attrList = [];
    Object.keys(formInfo).forEach(it => {
      if (it.includes('empty') || !formInfo.it) { // 去除多余的empty数据
        return;
      }
      attrList.push({
        attrCode: it,
        value: formInfo.it,
        attrValue: formInfo.it,
      });
    });
    const { onChange } = props;
    onChange(attrList);
  },
})(ExpandeForm));

export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
